import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 px-4 md:px-6 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20magical%20gradient%20background%20with%20floating%20light%20particles%20and%20soft%20bokeh%2C%20golden%20and%20amber%20tones%2C%20ethereal%20fantasy%20atmosphere%2C%20dreamy%20abstract%20texture%2C%20warm%20sunset%20colors%20blending%20with%20soft%20coral%20and%20peach%2C%20enchanting%20magical%20glow%2C%20smooth%20gradient%20with%20sparkling%20dust%20particles%2C%20elegant%20and%20mystical%20ambiance&width=1600&height=600&seq=cta-magic-color&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/35 to-black/50"></div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-white mb-4">
          准备好开启你的色彩冒险了吗？
        </h2>
        <p className="text-sm md:text-base text-white/80 mb-8 max-w-xl mx-auto leading-relaxed">
          好色精灵探访记的奇幻世界正在等待着你。加入我们，
          与六大精灵族一同踏上色彩魔法探索之旅，发现属于你的色彩故事！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/chise-jingling"
            className="whitespace-nowrap px-8 py-3 rounded-full bg-accent-500 text-white font-medium hover:bg-accent-600 transition-all duration-300 cursor-pointer text-sm md:text-base shadow-lg shadow-accent-500/30"
          >
            立即开始冒险
          </Link>
          <Link
            to="/about"
            className="whitespace-nowrap px-8 py-3 rounded-full border-2 border-white/50 text-white font-medium hover:bg-white/15 hover:border-white/70 transition-all duration-300 cursor-pointer text-sm md:text-base"
          >
            了解品牌故事
          </Link>
        </div>
      </div>
    </section>
  );
}